export default __webpack_public_path__ + "static/media/download_bgimage.ce469e7e.jpg";